import { useEffect, useState } from 'react';
import * as React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    Card,
    CardContent,
    Box,
    Button,
    Radio,
    CircularProgress,
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { MdEmail } from 'react-icons/md';
import LeadService from '../../../core/services/leadsService';
import { IconButton } from '@mui/material';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import { BsTelephoneFill } from 'react-icons/bs';
import logo_between from '../../assets/logo_between.png';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const InviteAgent = ({
    AssignAgentData,
    properties,
    AssignUser,
    selectedPropertyId,
    selectedDate,
    selectTime,
    googleLocation,
    latitude,
    longitude,
    handleClose,
    open,
    AllAgentsData,
    AllAgentsLeadData,
    setOpen,
    getLeads,
    searchValue
}) => {
    const navigate = useNavigate();
    const [selectedAgentId, setSelectedAgentId] = useState(null);
    const { lead } = AllAgentsLeadData;
    const [loading, setLoading] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const theme = useTheme();
    const FinalAssignAgents = async (selectedAgentId) => {
        try {
            // showExpirationToast = false;
            setLoading(true)
            const res = await LeadService.icaAgentAssignLead(selectedAgentId);
            if (res?.data?.success === true) {
                toast.success(res?.data.message);
                navigate('/get-leads');
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        } finally {
            setLoading(false)
        }
    };

    const handleCancelInvitation = async (leadId) => {
        try {
            setIsLoading(true)
            const res = await LeadService.getCancelInvitation(leadId);
            if (res.data.success) {
                toast.success('successfully cancelled');
                setOpen(false);
                await getLeads(searchValue);
            }
        }
        catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false)
        }
    };

    const handleRadioChange = (agentId) => {
        setSelectedAgentId(agentId);
    };
    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return 'green';
            case 'decline':
                return 'red';
            case 'pending':
                return 'blue';
            default:
                return 'textSecondary';
        }
    };
    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
        };

        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: "#bee5c6",
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            buyer_broker_signed: '#FABED4',
            cancelled: "#4C489B",
            valuation_appointment: "#7D9B00",
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
            follow_up: '#2e7a5c',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
            follow_up: '1px solid #2d6f55',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };
    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(lead?.status);
    return (
        <div>
            {/* {AssignAgentData?.length > 0 && properties?.length === 1 && !buttonClicked && (
                <div style={{ marginTop: '8px', textAlign: 'center', marginBottom: '5px' }}>
                    <Button
                        variant="contained"
                        style={{ background: '#ACABAB', marginBottom: '10px',width:'220px' }}
                        onClick={() => AssignUser(
                            AssignAgentData,
                            selectedPropertyId,
                            selectedDate,
                            selectTime,
                            googleLocation,
                            latitude,
                            longitude
                        )}
                    >
                        SEND INVITE TO AGENTS
                    </Button>
                </div>
            )} */}
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px', // Set the desired width for the scrollbar
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                            borderRadius: '10px', // Set the border radius for a rounded effect
                        },
                    }}
                />
                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    sx={{
                        '& .MuiDialog-paper': {
                            minWidth: '860px',
                            borderRadius: '22px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)' // Subtle shadow for depth
                        }
                    }}
                >
                    <DialogTitle>
                        <IconButton
                            style={{ position: 'absolute', top: '10px', right: '10px' }}
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                            Send Invite to Agent
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Box padding={2}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                <img src={logo_between} style={{ width: '45px', height: '45px', marginRight: '10px' }} alt="" />
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: '700', color: '#333' }}>
                                        {lead?.first_name} {lead?.last_name}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        📍 : {lead?.display_address}
                                    </Typography>
                                    <Box display="flex" alignItems="center">
                                        <LabelImportantIcon sx={{ fontSize: '14px', color: '#976b6bde', marginRight: '4px' }} />
                                        <Typography variant="body2" sx={{ color: 'rgb(161, 159, 157)' }}>
                                            {lead?.tag}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ marginLeft: 'auto' }}>
                                    <span style={{
                                        ...divStyle,
                                        borderRadius: '10px',
                                        padding: '7px',
                                        backgroundColor: '#e3f2fd',
                                        color: '#1e88e5'
                                    }}>
                                        {formattedStatus}
                                    </span>
                                </Box>
                            </div>

                            <Box display="flex" gap={2} marginBottom={2}>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        width: '127px',
                                        height: '38px',
                                        fontSize: '14px',
                                        borderColor: '#587DBF',
                                        color: '#587DBF',
                                        '&:hover': {
                                            backgroundColor: '#f1f1f1',
                                            borderColor: '#5b8dfd',
                                        },
                                    }}
                                >
                                    {lead?.lead_type}
                                </Button>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        width: '162px',
                                        height: '39px',
                                        borderColor: '#587DBF',
                                        color: '#587DBF',
                                        '&:hover': {
                                            backgroundColor: '#f1f1f1',
                                            borderColor: '#5b8dfd',
                                        },
                                    }}
                                >
                                    From {lead?.source}
                                </Button>
                                <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Tooltip title={lead?.email}>
                                        <IconButton>
                                            <MdEmail sx={{ fontSize: '20px', color: '#5379bd' }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={lead?.phone}>
                                        <IconButton>
                                            <BsTelephoneFill sx={{ fontSize: '18px', color: '#5379bd' }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>

                            <DialogContentText>
                                {AllAgentsData?.length === 0 ? (
                                    <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        No Data Found
                                    </Typography>
                                ) : (
                                    AllAgentsData?.map((data) => (
                                        <Card
                                            key={data.id}
                                            variant="outlined"
                                            sx={{
                                                mb: 2,
                                                mt: 2,
                                                borderRadius: '25px',
                                                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                            <CardContent>
                                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                                    <Box display="flex" alignItems="center">
                                                        <Avatar
                                                            alt={data?.user.name}
                                                            sx={{ height: '60px', width: '60px', marginRight: '20px' }}
                                                            src={`https://iconnctapp.com/` + data?.user.profile_image}
                                                        />
                                                        <Box>
                                                            <Typography sx={{ fontSize: '22px', fontWeight: '500', color: 'black' }}>
                                                                {data?.user.name}{' '}{data?.user.last_name}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '15px', color: 'black' }}>
                                                                📧: {data?.user.email}
                                                            </Typography>
                                                            <Box display="flex" justifyContent="space-between" mt={1}>
                                                                <Box display="flex" alignItems="center">
                                                                    <Typography>Score: 🎯</Typography>
                                                                    <Typography sx={{ fontWeight: '700', color: 'black', marginLeft: '5px' }}>
                                                                        {data?.user?.score}
                                                                    </Typography>
                                                                </Box>
                                                                <Box display="flex" alignItems="center">
                                                                    <Typography>Quota: 📊</Typography>
                                                                    <Typography sx={{ fontWeight: '700', color: 'black', marginLeft: '5px' }}>
                                                                        {data?.user?.quota}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Typography variant="subtitle1" sx={{ color: getStatusColor(data.status) }}>
                                                            Status: {data.status.charAt(0).toUpperCase() + data.status.slice(1)}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box>
                                                        {data.status === 'accepted' && (
                                                            <Radio
                                                                checked={selectedAgentId == data?.id}
                                                                onChange={() => handleRadioChange(data?.id)}
                                                                sx={{
                                                                    '& .MuiSvgIcon-root': {
                                                                        fontSize: 28,
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        {selectedAgentId == data.id && (
                                                            <Box display="flex" alignItems="center" mt={1}>
                                                                <Button
                                                                    disabled={loading}
                                                                    variant="contained"
                                                                    onClick={() => FinalAssignAgents(selectedAgentId)}
                                                                    sx={{
                                                                        backgroundColor: '#1e88e5',
                                                                        color: 'white',
                                                                        '&:hover': {
                                                                            backgroundColor: '#1976d2',
                                                                        },
                                                                    }}
                                                                >
                                                                    {loading && (
                                                                        <CircularProgress
                                                                            sx={{ visibility: loading ? '' : 'hidden' }}
                                                                        />
                                                                    )}
                                                                    ASSIGN LEAD
                                                                </Button>
                                                                
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    ))
                                )}
                            </DialogContentText>
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'center' }}>
                        <Button
                            onClick={() => handleCancelInvitation(lead?.id)}
                            sx={{
                                padding: '10px',
                                backgroundColor: 'gray',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#a8a8a8',
                                },
                            }}
                        >
                            Cancel Invitation
                        </Button>
                        <CircularProgress sx={{ visibility: isLoading ? '' : 'hidden' }} />
                    </DialogActions>
                </Dialog>
            </ThemeProvider>

        </div>
    )
}
export default InviteAgent
